import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const withLayout = (El) => (
    <Layout>
        <El />
    </Layout>
);

function App() {
    return (
        <SettingsProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={withLayout(Home)} />
                        <Route path="/about" element={withLayout(About)} />
                        <Route path="/services" element={withLayout(Services)} />
                        <Route path="/gallery" element={withLayout(Gallery)} />
                        <Route path="/contact" element={withLayout(Contact)} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                    <Toaster position="top-right" theme="dark" richColors />
                </BrowserRouter>
            </AuthProvider>
        </SettingsProvider>
    );
}

export default App;
